/**
 * 错误类型
 */
export var ErrorTypes;
(function (ErrorTypes) {
    /**
     * 服务器的 api 错误
     */
    ErrorTypes["Api"] = "API";
    /**
     * 第三方的 api 错误
     */
    ErrorTypes["VendorApi"] = "VENDOR_API";
    /**
     * 其他
     */
    ErrorTypes["Other"] = "Other";
})(ErrorTypes || (ErrorTypes = {}));
/**
 * 网络错误
 */
export const networkErrorMessages = [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'Network Error'
];
